(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-bed"] && !Shopify.designMode) return;
  try {
    
class CompleteTheBedCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ctb-track]');
    this.dotsContainer = this.querySelector('[data-ctb-dots]');
    if (!this.track) return;

    this.cards = Array.from(this.track.querySelectorAll('[data-ctb-card]'));
    this.buildDots();
    this.observeCards();
  }

  buildDots() {
    if (!this.dotsContainer || this.cards.length < 2) return;

    // A row that already fits every card needs no pagination — scrollWidth
    // stays equal to clientWidth on wide viewports where all cards are visible.
    if (this.track.scrollWidth <= this.track.clientWidth + 1) {
      this.dotsContainer.classList.add('complete-the-bed__dots--hidden');
      return;
    }

    this.dots = this.cards.map((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'complete-the-bed__dot';
      dot.setAttribute('aria-label', `${index + 1}`);
      dot.addEventListener('click', () => {
        card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      this.dotsContainer.appendChild(dot);
      return dot;
    });
    this.dots[0].classList.add('is-active');
  }

  observeCards() {
    if (!this.dots) return;

    // A batch can report more than one card past the 0.6 threshold at once
    // (two cards fit side by side in the track) — picking the highest
    // intersection ratio, rather than the last entry processed, keeps the
    // active dot matching whichever card is actually most in view.
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (!visible.length) return;
        const best = visible.reduce((a, b) => (b.intersectionRatio > a.intersectionRatio ? b : a));
        const index = this.cards.indexOf(best.target);
        if (index === -1) return;
        this.dots.forEach((dot) => dot.classList.remove('is-active'));
        this.dots[index].classList.add('is-active');
      },
      { root: this.track, threshold: 0.6 }
    );

    this.cards.forEach((card) => observer.observe(card));
  }
}

if (!customElements.get('complete-the-bed-carousel')) {
  customElements.define('complete-the-bed-carousel', CompleteTheBedCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
